

module.exports = __webpack_require__.stylable.create(
    "DropDownCategories1266808962",
    {"classes":{"root":"DropDownCategories1266808962__root","TPADropdownBase":"","dropdown":"Dropdown846562525__dropdown","title":"DropdownOption4205681397__title","arrowIcon":"DropdownBase2521854069__arrowIcon"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    10,
    "DropDownCategories1266808962",
    null
);
